/* lib/enums.js — статусы, аллергены, тона, виды сущностей + UI-константы.
   Источник: 01-foundation-shell-tokens.md §4. Перенесено из mock/_enums.js при
   снятии мок-слоя: это чистые UI-константы (не данные), потому живут в lib/.
   ХЕНДОФФ: 1:1 во frontend/src/lib/enums.js. */

const TTK_STATUS = { READY: 'ready', UNBOUND: 'unbound', STUB: 'stub' };
const CONFIDENCE = { HIGH: 'high', MEDIUM: 'medium', LOW: 'low' };
const COST_STATUS = { OK: 'ok', PARTIAL: 'partial', MISSING: 'missing' };

const ALLERGENS = [
  { id: 'gluten', label: 'Глютен' },
  { id: 'crustaceans', label: 'Ракообразные' },
  { id: 'eggs', label: 'Яйца' },
  { id: 'fish', label: 'Рыба' },
  { id: 'peanuts', label: 'Арахис' },
  { id: 'soybeans', label: 'Соя' },
  { id: 'milk', label: 'Молоко' },
  { id: 'nuts', label: 'Орехи' },
  { id: 'celery', label: 'Сельдерей' },
  { id: 'mustard', label: 'Горчица' },
  { id: 'sesame', label: 'Кунжут' },
  { id: 'sulphites', label: 'Сульфиты' },
  { id: 'lupin', label: 'Люпин' },
  { id: 'molluscs', label: 'Моллюски' },
];

const TONE = { SUCCESS: 'success', DANGER: 'danger', WARNING: 'warning', ACCENT: 'accent', MUTED: 'muted' };
const ENTITY_KIND = { CARD: 'card', TTK: 'ttk', MENU: 'menu' };

// соответствие тона → семантический токен (для Toast/бейджей)
const TONE_TOKEN = {
  success: 'ok', danger: 'bad', warning: 'warn', accent: 'accent', muted: 'neutral',
};

// ЕДИНЫЙ словарь badge-токен → глиф (P2-04): чтобы Badge и Toast не дрейфовали.
// Badge потребляет напрямую, Toast — через TONE_TOKEN (семантический тон → badge-токен).
// accent — 'sparkles' (AI/акцент), info — 'info' (нейтральная подсказка).
const TONE_GLYPH = {
  ok: 'check', warn: 'alert-triangle', bad: 'alert-circle', info: 'info', accent: 'sparkles', neutral: null,
};

/* ── Демо-наборы для витрины /dev/uikit (S1) ── */
const DEMO_STATUSES = ['ready', 'unbound', 'stub', 'draft', 'done', 'failed', 'confirming', 'recognizing'];
const DEMO_COST_STATUSES = ['ok', 'partial', 'missing'];
const DEMO_KIND_LABELS = ['Блюдо', 'Полуфабрикат', 'Ингредиент'];
const DEMO_ALLERGENS = ['Глютен', 'Молоко', 'Яйца', 'Орехи', 'Рыба', 'Соя', 'Кунжут'];
const DEMO_FC_VALUES = [18, 27, 35, 42, 55];          // для FoodCostBadge
const DEMO_CONFIDENCE_LEVELS = [0.92, 0.74, 0.41];    // hi / medium / low

// человекочитаемые подписи статусов (цвет+ТЕКСТ — требование доступности).
// ЕДИНЫЙ источник подписей и для бейджей, и для опций фильтра реестра (P2-35):
// stub (пустая ТТК: только название/выход) ≠ draft (несохранённый черновик). Подпись stub —
// «Без рецепта» (Л6, kitchen-ux E2): как в реестрах ТТК (TTK_STATUS_LABEL) — бейдж редактора,
// снимка версии и витрины говорит то же; прежнее «Заготовка» путалось с полуфабрикатом.
// Полнота себестоимости — ОДИН словарь на продукт (kitchen-ux D3 круг 3, решение лида):
// реестр и редактор ТТК, строка блюда в меню, колонка «Полнота себестоимости» реестра
// меню, сравнение версий (бэкенд — versioning/diff.py COST_STATUS_LABEL, те же слова).
// `pending` — у ТТК нет состава. Подписи API `cost_status_label` («Готова / Нет цен /
// Не считалась») в интерфейсе не показываем.
const COST_STATUS_LABEL = { ok: 'Полная', partial: 'Частичная', missing: 'Нет данных', pending: 'Нет состава' };

const STATUS_LABEL = {
  ready: 'Готова', unbound: 'Не привязана', stub: 'Без рецепта', draft: 'Черновик',
  done: 'Завершено', failed: 'Ошибка', confirming: 'Подтверждение', recognizing: 'Распознаётся',
  ok: COST_STATUS_LABEL.ok, partial: COST_STATUS_LABEL.partial, missing: COST_STATUS_LABEL.missing,
  active: 'Активно', archived: 'В архиве',
};
// статус → семантический тон бейджа
const STATUS_TONE = {
  ready: 'ok', done: 'ok', ok: 'ok', active: 'ok',
  unbound: 'warn', stub: 'neutral', draft: 'neutral', partial: 'warn', archived: 'neutral',
  failed: 'bad', missing: 'bad',
  confirming: 'info', recognizing: 'accent',
};

export const enums = {
  TTK_STATUS, CONFIDENCE, COST_STATUS, ALLERGENS, TONE, ENTITY_KIND, TONE_TOKEN, TONE_GLYPH,
  DEMO_STATUSES, DEMO_COST_STATUSES, DEMO_KIND_LABELS, DEMO_ALLERGENS,
  DEMO_FC_VALUES, DEMO_CONFIDENCE_LEVELS, STATUS_LABEL, STATUS_TONE, COST_STATUS_LABEL,
};

// кодовое слово подтверждения удаления аккаунта (SecurityTab). Перенесено из
// mock/account.js — чистая UI-константа.
export const DELETE_CODE_WORD = 'УДАЛИТЬ';
